import React from "react";
import { Hero } from "./components/sections/Hero";
import { MiniTestimonials } from "./components/sections/MiniTestimonials";
import { Problem } from "./components/sections/Problem";
import { Tomos } from "./components/sections/Tomos";
import { Bonos } from "./components/sections/Bonos";
import { UrgencyBar } from "./components/sections/UrgencyBar";
import { Pricing } from "./components/sections/Pricing";
import { KitComparison } from "./components/sections/KitComparison";
import { Testimonials } from "./components/sections/Testimonials";
import { Guarantee } from "./components/sections/Guarantee";
import { Faq } from "./components/sections/Faq";
import { CostOfInaction } from "./components/sections/CostOfInaction";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <main className="w-full min-h-full bg-black text-white antialiased selection:bg-[#e10600] selection:text-white" data-id="element-0" data-mp="23vciyq2516ak">
      <Hero data-id="element-1" data-mp="3ik7jmqgv0tve" />
      <MiniTestimonials data-id="element-2" data-mp="3ikqyfyb7r257" />
      <Problem data-id="element-3" data-mp="3ijfx0558q6h9" />
      <Tomos data-id="element-4" data-mp="3ijpef4c7z5bc" />
      <Bonos data-id="element-5" data-mp="3ii4r9zs8ioni" />
      <UrgencyBar data-id="element-6" data-mp="3mlawr57iwbsx" />
      <Pricing data-id="element-7" data-mp="3mkre1ma1tjdu" />
      <KitComparison data-id="element-8" data-mp="3mk86mzi0yde2" />
      <Testimonials data-id="element-9" data-mp="3mjq2zht18ww4" />
      <Guarantee data-id="element-10" data-mp="3mj6jhwnqi0fz" />
      <Faq data-id="element-11" data-mp="3rcj846sey78q" />
      <CostOfInaction data-id="element-12" data-mp="3rbzmog3k10py" />
      <FinalCta data-id="element-13" data-mp="3rdkh85pvcjnt" />
      <Footer data-id="element-14" data-mp="3rd19fhtxnbni" />
    </main>;
}